<mat-card appearance="raised" class="code-form--container mat-elevation-z12">
  <div class="code-form--header">
    <h4 class="code-form--title">{{ sysText[page + '_verificationForm_title'] }}</h4>
    @if (otpIsPhone) {
      <p
        class="body2 code-form--subtitle">
        {{ sysText[page + '_verificationForm_subtitlePhone']}} {{otpDest}}
      </p>
    }
    @if (!otpIsPhone) {
      <p
        class="body2 code-form--subtitle">
        {{ sysText[page + '_verificationForm_subtitleEmail']}} {{otpDest}}
      </p>
    }
  </div>
  <mat-card-content>
    <form
      [formGroup]="verificationForm"
      (ngSubmit)="!isSubmitting && onSubmit()"
      class="code-form--form">
      <mat-form-field color="accent">
        <mat-label>{{ sysText[page + '_verificationForm_enterCode'] }}</mat-label>
        <input
          #codeInput
          type="number"
          matInput
          formControlName="code"
          autocomplete="off"/>
          <mat-error>{{ code.errors?.required ? (sysText.required | capitalizefirst) : code.errors?.msError }}</mat-error>
        </mat-form-field>
        @if (options.rememberMe.show) {
          <mat-checkbox formControlName="rememberMe">{{ sysText[page + '_verificationForm_remember'] }}</mat-checkbox>
        }
        <!-- submit keeps focus while submitting: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and (ngSubmit) is guarded -->
        <button
          type="submit"
          mat-flat-button
          color="accent"
          class="button code-form--button"
          [disabled]="isSubmitting"
          disabledInteractive
          [showProgress]="isSubmitting"
          [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null">
          {{ sysText[page + '_verificationForm_button'] }}
          <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
        </button>
      </form>
      <div class="code-form--link caption">
        <button type="button" class="button-reset" (click)="onResend()">
          {{ sysText[page + '_verificationForm_link'] }}
        </button>
        @if (options.secondaryLink.show) {
          <button type="button" (click)="onEmailCode()" class="button-reset code-form--link__secondary">
            {{ sysText[page + '_verificationForm_secondaryLink'] }}
          </button>
        }
        @if (options.goBack.show) {
          <button type="button" (click)="onGoBack()" class="button-reset code-form--link__secondary">
            {{ sysText[page + '_verificationForm_goBack'] }}
          </button>
        }
      </div>

    </mat-card-content>
  </mat-card>
